import React from 'react'
import {Link, LinkProps} from 'react-router-dom'
import type {To} from 'react-router-dom'
import {useI18n} from './I18nContext'
import {withLocalePath} from './localePaths'

function localizeTo(to: To, locale: ReturnType<typeof useI18n>['locale']): To {
  if (typeof to === 'string') {
    if (
      !to ||
      to.startsWith('http://') ||
      to.startsWith('https://') ||
      to.startsWith('//') ||
      to.startsWith('mailto:') ||
      to.startsWith('tel:')
    ) {
      return to
    }
    const q = to.indexOf('?')
    const hash = to.indexOf('#')
    let end = to.length
    if (q >= 0) end = Math.min(end, q)
    if (hash >= 0) end = Math.min(end, hash)
    const pathOnly = to.slice(0, end)
    const rest = end < to.length ? to.slice(end) : ''
    const normalized =
      !pathOnly || pathOnly === '/'
        ? '/'
        : pathOnly.startsWith('/')
          ? pathOnly
          : `/${pathOnly}`
    return withLocalePath(locale, normalized) + rest
  }
  const pathname = to.pathname || ''
  return {...to, pathname: withLocalePath(locale, pathname || '/')}
}

/**
 * Same as react-router `Link`, but prefixes the current UI locale (`/bg/...`, `/en/...`).
 */
export function LocalLink(props: LinkProps) {
  const {locale} = useI18n()
  const to = localizeTo(props.to, locale)
  return <Link {...props} to={to} />
}
